import { Button } from "antd";
import { useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function AdminBudgetExport({ month, budgets = [] }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    const xport = useCallback(() => {
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);
        XLSX.writeFile(wb, `${t('budget')} ${month}.xlsx`);
    }, [t, month]);

    return (
        <>
            <table ref={tableRef} style={{ display: 'none' }}>
                <tbody>
                    {/* Title row */}
                    <tr>
                        <td colSpan={5}>{t('budget')} {month}</td>
                    </tr>
                    {/* Header row */}
                    <tr>
                        <td>shopCode</td>
                        <td>shopName</td>
                        <td>budget</td>
                        <td>productivity</td>
                    </tr>
                    {/* Data rows */}
                    {budgets.map(shop => (
                        <tr key={shop.shopId}>
                            <td>{shop.shopCode}</td>
                            <td>{shop.shopName}</td>
                            <td>{shop.budget ?? ''}</td>
                            <td>{shop.productivity ?? ''}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Button
                type='primary'
                size="large"
                icon={<CloudDownloadOutlined />}
                onClick={xport}
            >
                {t('exportExcel')}
            </Button>
        </>
    );
}
